import { isString } from '../../../utils';

var formatPhonePattern = pattern => {
  if (!isString(pattern)) {
    return '';
  }

  return pattern.replace(/\\\\/g, '\\');
};

var getMaskedPhoneNumber = (value, maskStr) => {
  if ([value, maskStr].some(v => !isString(v))) {
    return '';
  }

  var valueIndex = 0;
  var maskIndex = 0;
  var maskedInput = '';

  while (maskIndex < maskStr.length && valueIndex < value.length) {
    var nextMaskedChar = maskStr[maskIndex];
    var nextChar = nextMaskedChar === '0' ? value[valueIndex++] : nextMaskedChar;
    maskIndex++;
    maskedInput += nextChar;
  }

  return maskedInput;
};

export { formatPhonePattern, getMaskedPhoneNumber };